import { clips } from "./clips";
import { Clip } from './models';

export interface TheFoldScoreOptions {
  algorithm?: number;
  crossfadeTime?: number;
  minDuration?: number;
}

export const TheFoldScore = (options: TheFoldScoreOptions) => {
  const availableGroups = {};
  const availableKeys = {};
  const availableLyrics = {};
  const availableTracks = {};
  const availableVocalStyles = {};
  const instrumentCounter = {};
  const poolCounter = {};
  const algorithm = options.algorithm || 0; // track sorting algorithm
  const crossfadeTime = options.crossfadeTime || 0.5; // time in seconds
  let currentDuration: number = 0; // time in seconds
  let totalMinDuration: number = options.minDuration || 900; // time in seconds
  let currentTracklist: Clip[] = [];
  let currentTracklistId = "";

  // populate available tracks
  for (let index in clips) {
    const clip = clips[index];
    availableGroups[clip.group] = true;
    availableKeys[clip.rootTone + clip.rootMode.toString()] = true;
    poolCounter[clip.poolName] = 0;
    instrumentCounter[clip.instrumentation[0]] = 0;
    availableTracks[clip.trackName] = true;
    availableVocalStyles[clip.vocal] = true;
    if (clip.lyrics) {
      availableLyrics[clip.lyrics] = true;
    }
  }

  const clipPool = [...clips];

  const clipSort = (a: Clip, b: Clip) => {
    // if (a.intensity !== b.intensity) return a.intensity - b.intensity;
    // if (a.density !== b.density) return a.density - b.density;
    // if (a.lyrics && !b.lyrics) return 1;
    // if (!a.lyrics && b.lyrics) return -1;
    // const poolOrder = ["CMPS", "VRTX", "MOTH", "PNCL"]; // lowerst priority to highest
    // return poolOrder.indexOf(a.poolName) - poolOrder.indexOf(b.poolName);
    if (algorithm === 1) {
      return a.vocal - b.vocal;
    }
    if (a.group < b.group) return -1;
    if (a.group > b.group) return 1;
    return 0;
  } 

  const reset = () => {
    let clip: Clip;
    currentDuration = 0;
    currentTracklist = [];
    currentTracklistId = "";
    for (let index in clipPool) {
      clip = clips[index];
      availableGroups[clip.group] = true;
      availableKeys[clip.rootTone + clip.rootMode.toString()] = true;
      instrumentCounter[clip.instrumentation[0]] = 0;
      poolCounter[clip.poolName] = 0;
      availableTracks[clip.trackName] = true;
      availableVocalStyles[clip.vocal] = true;
      if (clip.lyrics) {
        availableLyrics[clip.lyrics] = true;
      }
    }
  }

  const load = (versionId: string) => {
    const parsedIds = versionId.match(/.{1,2}/g) || [];
    const tracklist: Clip[] = [];
    let numId: number;
    let foundClip: Clip | undefined;
    for (let id of parsedIds) {
      numId = parseInt(id, 10);
      foundClip = clips.find(clip => clip.id === numId);
      if (foundClip != undefined) {
        tracklist.push(foundClip);
      }
    }

    if (tracklist.length > 0) {
      currentTracklist = tracklist;
      currentTracklistId = versionId;
      //console.log(currentTracklist);

      // fetch("/access.php", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({ version: versionId }),
      // });

      return currentTracklist;
    }

    return [];
  }

  const generate = () => {
    let selectedClip: Clip,
        selectedClipIndex: number,
        filteredPool: Clip[];

    while (currentDuration < totalMinDuration) {
      filteredPool = clipPool.filter((clip) => {
        const lyricsCheck = clip.lyrics ? availableLyrics[clip.lyrics] === true : true;
        return (
          availableGroups[clip.group] === true &&
          availableKeys[clip.rootTone + clip.rootMode.toString()] === true &&
          instrumentCounter[clip.instrumentation[0]] < 2 &&
          poolCounter[clip.poolName] < 2 &&
          availableTracks[clip.trackName] === true &&
          availableVocalStyles[clip.vocal] === true &&
          lyricsCheck
        );
      });

      selectedClipIndex = Math.floor(Math.random() * (filteredPool.length - 1));
      selectedClip = filteredPool.splice(selectedClipIndex, 1)[0];
      //console.log('filteredPool:', filteredPool, currentDuration + (selectedClip.duration - crossfadeTime));

      if (selectedClip != null) {
        currentTracklist.push(selectedClip);
        availableGroups[selectedClip.group] = false;
        availableKeys[selectedClip.rootTone + selectedClip.rootMode.toString()] = false;
        instrumentCounter[selectedClip.instrumentation[0]]++;
        poolCounter[selectedClip.poolName]++;
        availableTracks[selectedClip.trackName] = false;
        availableVocalStyles[selectedClip.vocal] = false;
        if (selectedClip.lyrics) {
          availableLyrics[selectedClip.lyrics] = false;
        }
        currentDuration += (selectedClip.duration - crossfadeTime);
      } else {
        break;
      }
    }

    // sort and append temporary tracklist here
    currentTracklist.sort(clipSort);

    if (algorithm === 0) {
      const lastClip = currentTracklist.pop() as Clip;
      currentTracklist.reverse();
      currentTracklist.push(lastClip);
    }

    // double-check if it's long enough (corner cases)
    if (currentDuration < totalMinDuration || currentTracklist.length < 4) {
      reset();
      return generate();
    }

    // tracklist done, generate tracklistId string
    //console.log(currentTracklist, algorithm);

    let tracklistId = "";
    for (let clipIndex of currentTracklist) {
      if (clipIndex.id !== undefined) {
        if (clipIndex.id < 10) {
          tracklistId += "0";
        }
        tracklistId += clipIndex.id.toString();
      }
    }
    currentTracklistId = tracklistId;

    return currentTracklist;
  }

  const getCurrentTracklistId = () => { return currentTracklistId; }
  const findClipById = (id: number) => { clipPool.find((c) => { return c.id === id}) }

  return {
    findClipById,
    generate,
    getCurrentTracklistId,
    load,
  }
}
